import {Component, Input, OnInit} from '@angular/core';
import { UntypedFormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {FormContainerComponent} from '../form-container/form-container.component';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';

@Component({
    selector: 'tw-form-select',
    templateUrl: './form-select.component.html',
    styleUrls: ['./form-select.component.css'],
    imports: [FormsModule, ReactiveFormsModule, MatFormField, MatSelect, MatOption]
})
export class FormSelectComponent extends FormContainerComponent implements OnInit {




    constructor(public fb: UntypedFormBuilder) {
        super(fb);
    }

    ngOnInit() {
    }

}
